import { TabsProps } from '@mui/material';
import { TabConfigItem } from '../../@types';
import StyledHeaderTabs from '../atoms/StyledHeaderTabs';

type UserListTabsProps = TabsProps & {
  tabConfig: TabConfigItem<string>[];
};

const UserListTabs = (props: UserListTabsProps) => <StyledHeaderTabs {...props} />;

export default UserListTabs;
